module.exports = __webpack_public_path__ + "static/media/compressor.911cc7be.png";